import { IconAlertTriangleFilled } from "@tabler/icons-react";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import { MantineIconCell } from "../../../mantine/mrt/components/cell/MantineIconCell";
import type { DirektvermarktungContractOverviewResponse } from "../Direktvermarktung.types";
import { useDirektvermarktungContract } from "../hooks/useDirektvermarktungContract";

function getGeneratorsColumn(): MRT_ColumnDef<DirektvermarktungContractOverviewResponse> {
  return {
    header: "Erzeuger",
    Cell: ({ row }) => {
      const {
        data: contractData,
        isLoading: direktvermarktungContractLoading
      } = useDirektvermarktungContract(row.original.id);

      if (direktvermarktungContractLoading) {
        return "Lade Erzeuger";
      }

      const generatorCount = contractData?.generation_shares?.length ?? 0;
      if (generatorCount > 0) {
        return `${generatorCount} Erzeuger`;
      }
      return (
        <MantineIconCell
          iconColor="var(--mantine-color-warning-filled)"
          IconComponent={IconAlertTriangleFilled}
          renderedCellValue="Keine Erzeuger"
        />
      );
    }
  };
}

export { getGeneratorsColumn };
